export default __webpack_public_path__ + "static/wp-c890502f362c25598ed2bbaa289e2e8b.png";